// Soft UI Dashboard PRO React layouts
import SignInIllustration from "layouts/Signin/sign-in";
import Flows from "layouts/Flows";
import { Flow } from "layouts/pages/library/flow";
import Calendar from "layouts/Calendar";
// import Billing from "layouts/pages/billing";
import Settings from "layouts/pages/settings";
import Invoice from "layouts/pages/invoice";
import ManageUsers from "layouts/pages/users/reports";
import Illustration from "layouts/pages/sign-up/illustration";
import Company from "layouts/pages/account/company";
import RolesAndPermissions from "layouts/pages/roles-and-permissions";
import CredentialManagement from "layouts/pages/credential-management";
import { LibraryConnector } from "layouts/pages/library/connector";
import { LibraryCredential } from "layouts/pages/library/credential";
import { LibraryIntegrations } from "layouts/pages/library/integrations";
import ScheduleInfo from "layouts/pages/library/schedules/components/ScheduleInfo";

import Dashboard from "layouts/pages/home";

// Soft UI Dashboard PRO React icons
// import Subscription from "layouts/pages/settings/components/Subscription";
import FlowDesigner from "layouts/Flow Designer";
import Verification from "layouts/Verification/verification";
import TwoStepAuthentication from "layouts/Verification/twostepauthentication";
import DbWaitingPage from "layouts/Verification/db-waiting-page";
import RolesAndPermissionsDetails from "layouts/pages/roles-and-permissions/components/DetailsView";
import Connector from "layouts/pages/connector";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import Error404 from "layouts/Error/404";
import Maintenance from "layouts/Error/Maintenance";
import HealthChecker from "healthchecker/healthcheck";
import { LibraryIntegration } from "layouts/pages/library/integration";
import { ThemedHomeIcon, ThemedWorkspaceIcon, ThemedAdministrationIcon, ThemedHelpIcon } from "assets/CXFIcons/Portal/Navigation";
import { getEnv } from "helpers/environment";
import Logs from "layouts/pages/logs";

export const getAppRoutes = () => {
   const logsAvailability = getEnv("IS_COMPONENT_DOWN_LOGS") ?? getEnv("IS_COMPONENT_DOWN_ANALYTICS_LOGS");
   return [
      // ================================================ Start of SideNav content ================================

      {
         type: "collapse",
         name: "Home",
         key: "home",
         route: "/home",
         icon: <ThemedHomeIcon title="Home" />,
         component: <Dashboard />, //must create the dashboard component
         noCollapse: true,
         isComponentDown: getEnv("IS_COMPONENT_DOWN_HOME")
      },
      {
         type: "collapse",
         name: "Quick Start",
         key: "quick-start",
         route: "/quick-start",
         icon: <RocketLaunchIcon size="12px" title="Home" />,
         component: getEnv("IS_COMPONENT_DOWN_QUICK_START") === "active" ? <Dashboard /> : <Error404 />,
         noCollapse: true,
         isComponentDown: getEnv("IS_COMPONENT_DOWN_QUICK_START")
      },
      {
         type: "collapse",
         name: "Workspace",
         key: "workspace",
         icon: <ThemedWorkspaceIcon />,
         isComponentDown: getEnv("IS_COMPONENT_DOWN_LIBRARY"),
         collapse: [
            {
               name: "Flows",
               key: "flows",
               route: "/workspace/flows",
               isComponentDown: getEnv("IS_COMPONENT_DOWN_WORKFLOW_MGMT"),
               component: getEnv("IS_COMPONENT_DOWN_WORKFLOW_MGMT") === "active" ? <Flows /> : <Error404 />
            },
            {
               name: "Schedules",
               key: "schedules",
               route: "/workspace/schedules",
               isComponentDown: getEnv("IS_COMPONENT_DOWN_SCHEDULER"),
               component: getEnv("IS_COMPONENT_DOWN_SCHEDULER") === "active" ? <Calendar /> : <Error404 />
            },
            {
               name: "Connectors",
               key: "connectors",
               route: "/workspace/connectors",
               isComponentDown: getEnv("IS_COMPONENT_DOWN_CONNECTOR"),
               component: getEnv("IS_COMPONENT_DOWN_CONNECTOR") === "active" ? <Connector /> : <Error404 />
            },
            {
               name: "Integrations",
               key: "integrations",
               route: "/workspace/integrations",
               isComponentDown: getEnv("IS_COMPONENT_DOWN_INTEGRATION"),
               component: getEnv("IS_COMPONENT_DOWN_INTEGRATION") === "active" ? <LibraryIntegrations /> : <Error404 />
            },
            {
               name: "Logs",
               key: "logs",
               route: "/workspace/logs",
               isComponentDown: logsAvailability,
               component: logsAvailability === "active" ? <Logs /> : <Error404 />
         }
         ]
      },
      // {
      //   type: "collapse",
      //   name: "Analytics",
      //   key: "analytics",
      //   icon: <ThemedAnalyticsIcon />,
      //   isComponentDown: getEnv("IS_COMPONENT_DOWN_ANALYTICS"),
      //   collapse: [
      //     {
      //       name: "Workflows",
      //       key: "workflows",
      //       route: "/analytics/workflows",
      //       component:
      //         getEnv("IS_COMPONENT_DOWN_ANALYTICS") === "active" ? <Dashboard /> : <Error404 />,
      //       isComponentDown: getEnv("IS_COMPONENT_DOWN_ANALYTICS_WORK_FLOWS")
      //     },
      //     {
      //       name: "General",
      //       key: "analytics-home",
      //       route: "/analytics/",
      //       component:
      //         getEnv("IS_COMPONENT_DOWN_ANALYTICS") === "active" ? <Dashboard /> : <Error404 />,
      //       isComponentDown: getEnv("IS_COMPONENT_DOWN_ANALYTICS")
      //     },
      //     {
      //       name: "Integrations",
      //       key: "integrations",
      //       route: "/analytics/integrations",
      //       component:
      //         getEnv("IS_COMPONENT_DOWN_ANALYTICS") === "active" ? <Dashboard /> : <Error404 />,
      //       isComponentDown: getEnv("IS_COMPONENT_DOWN_ANALYTICS_INTEGRATIONS")
      //     },
      //     {
      //       name: "Logs",
      //       key: "logs",
      //       route: "/analytics/logs",
      //       component: getEnv("IS_COMPONENT_DOWN_ANALYTICS") === "active" ? <Logs /> : <Error404 />,
      //       isComponentDown: getEnv("IS_COMPONENT_DOWN_ANALYTICS_LOGS")
      //     }
      //   ]
      // },
      {
         type: "collapse",
         name: "Resources",
         key: "resources",
         icon: <AutoAwesomeIcon size="12px" />,
         isComponentDown: getEnv("IS_COMPONENT_DOWN_RESOURCES"),
         collapse: [
            {
               name: "Marketplace",
               key: "marketplace",
               route: "/resources/marketplace",
               component: getEnv("IS_COMPONENT_DOWN_MARKET_PLACE") === "active" ? <Dashboard /> : <Error404 />,
               isComponentDown: getEnv("IS_COMPONENT_DOWN_MARKET_PLACE")
            }
         ]
      },

      {
         type: "collapse",
         name: "Administration",
         key: "administration",
         icon: <ThemedAdministrationIcon />,
         isComponentDown: getEnv("IS_COMPONENT_DOWN_ADMINISTRATION"),
         collapse: [
            // {
            //   name: "Account",
            //   key: "account",
            //   route: "/administration/account",
            //   component:
            //     getEnv("IS_COMPONENT_DOWN_SHARED_INTEGRATIONS") === "active" ? (
            //       <Dashboard />
            //     ) : (
            //       <Error404 />
            //     ),
            //   isComponentDown: getEnv("IS_COMPONENT_DOWN_SHARED_INTEGRATIONS")
            // },
            {
               name: "Company",
               key: "company",
               route: "/administration/company",
               component: getEnv("IS_COMPONENT_DOWN_COMPANY") === "active" ? <Company /> : <Error404 />,
               isComponentDown: getEnv("IS_COMPONENT_DOWN_COMPANY")
            },
            // {
            //   name: "Billing",
            //   key: "billing",
            //   route: "/administration/billing",
            //   component: getEnv("IS_COMPONENT_DOWN_BILLING") === "active" ? <Billing /> : <Error404 />,
            //   isComponentDown: getEnv("IS_COMPONENT_DOWN_BILLING")
            // },
            {
               name: "Users",
               key: "users",
               route: "/administration/users",
               component: getEnv("IS_COMPONENT_DOWN_USERS") === "active" ? <ManageUsers /> : <Error404 />,
               isComponentDown: getEnv("IS_COMPONENT_DOWN_USERS")
            },
            // {
            //   name: "Subscriptions",
            //   key: "subscriptions",
            //   route: "/administration/subscriptions",
            //   component:
            //     getEnv("IS_COMPONENT_DOWN_SUBS") === "active" ? <Subscription /> : <Error404 />,
            //   isComponentDown: getEnv("IS_COMPONENT_DOWN_SUBS"),
            //   visuallyHidden: true
            // },
            {
               name: "Roles and Permissions",
               key: "roles-and-permissions",
               route: "/administration/roles-and-permissions",
               component: getEnv("IS_COMPONENT_DOWN_ROLES_PERMISSION") === "active" ? <RolesAndPermissions /> : <Error404 />,
               isComponentDown: getEnv("IS_COMPONENT_DOWN_ROLES_PERMISSION")
            },
            {
               name: "Credential Management",
               key: "credential-management",
               route: "/administration/credential-management",
               component: <CredentialManagement />,
               isComponentDown: "active"
            }
         ]
      },
      {
         type: "collapse",
         name: "Help",
         key: "help",
         icon: <ThemedHelpIcon />,
         href: "https://cxfabric.io/docs/",
         isComponentDown: getEnv("IS_COMPONENT_DOWN_HELP")
      },
      // {
      //   type: "collapse",
      //   name: "Help",
      //   key: "help",
      //   icon: <ThemedHelpIcon />,
      //   isComponentDown: getEnv("IS_COMPONENT_DOWN_HELP"),
      //   collapse: [
      //     {
      //       name: "Documentation",
      //       key: "/help/documentation",
      //       href: "https://cxfabric.io/docs/",
      //       isComponentDown: getEnv("IS_COMPONENT_DOWN_DOCUMENTATION")
      //     },
      //     {
      //       name: "Support",
      //       key: "/help/support",
      //       href: "https://support.cxfabric.io/tickets-view?offset=0",
      //       isComponentDown: getEnv("IS_COMPONENT_DOWN_SUPPORT")
      //     }
      //   ]
      // },

      // ================================================ End of SideNav content ================================
      {
         key: "invoice",
         route: "/account/invoice/:inv_Id",
         component: <Invoice />
      },
      {
         route: "/authentication/sign-in",
         key: "sign-in",
         component: <SignInIllustration />
      },
      {
         route: "/authentication/verification",
         key: "verification",
         component: <Verification />
      },
      {
         route: "/authentication/db-waiting-page",
         key: "verification",
         component: <DbWaitingPage />
      },
      {
         route: "/authentication/otp",
         key: "verification-otp",
         component: <TwoStepAuthentication />
      },
      {
         route: "/authentication/sign-up/illustration",
         key: "sign-up",
         component: <Illustration />
      },
      {
         route: "/account/users/user-edit/:id",
         key: "user-edit",
         component: <Settings />
      },
      {
         route: "/account/users/profile-overview/",
         key: "profile-overview",
         component: <Settings forView />
      },
      {
         route: "/account/users/profile-overview/:id",
         key: "profile-overview",
         component: <Settings forView />
      },
      {
         route: "/designer",
         key: "builder",
         component: <FlowDesigner />
      },
      {
         route: "/designer/:id",
         key: "builder",
         component: <FlowDesigner />
      },
      {
         route: "/home/profile",
         key: "my-profile",
         component: <Dashboard />
      },
      {
         route: "/privacy-and-security",
         key: "/privacy-and-security",
         component: <Dashboard />
      },
      // {
      //   route: "/home/settings",
      //   key: "settings",
      //   component: <Dashboard />
      // },
      {
         route: "/administration/roles-and-permissions/:roleId",
         key: "role-users",
         component: <RolesAndPermissionsDetails />
      },
      // {
      //   route: "/customer-subscriptions",
      //   key: "customer-subscriptions",
      //   component: <CustomerSubscriptions />
      // },
      { route: "/connector/:slug/", key: "connector-library", component: <LibraryConnector /> },
      {
         route: "/connector/:slug/:flowId",
         key: "connector-library",
         component: <LibraryConnector />
      },
      { route: "/integration/:slug", key: "integrations-library", component: <LibraryIntegration /> },
      { route: "/flow/:slug", key: "flow-detail", component: <Flow /> },
      { route: "/credential/:slug", key: "credential-detail", component: <LibraryCredential /> },
      { route: "/schedule/:slug", key: "schedule-detail", component: <ScheduleInfo /> },
      {
         name: "Error 404",
         key: "error-404",
         route: "/error/404",
         component: <Error404 />
      },
      {
         name: "Maintenance",
         key: "maintenance",
         route: "/maintenance",
         component: <Maintenance />
      },
      {
         key: "healthcheck",
         route: "/health-check",
         serviceUrl: "cxf-frontend-dev.cxfabric.io",
         component: <HealthChecker />
      }
   ];
};
